import React from 'react';
import {Icon} from '@chakra-ui/react';
import {
  TablerBriefcase,
  TablerCalendar,
  TablerClock,
  TablerGlobe,
  TablerHash,
  TablerStack2,
  TablerMail,
  TablerMapPin,
  TablerPhone,
  TablerUser,
  TablerUsers,
  TablerVideo,
} from '../../icons';
import MetaPill from './MetaPill';

export const INFO_PILL_ICONS: Record<string, any> = {
  accountNo: TablerHash,
  age: TablerUser,
  calendar: TablerCalendar,
  dob: TablerCalendar,
  duration: TablerClock,
  email: TablerMail,
  gender: TablerUser,
  inPerson: TablerMapPin,
  language: TablerGlobe,
  mrn: TablerHash,
  pcp: TablerBriefcase,
  phone: TablerPhone,
  sessions: TablerStack2,
  shared: TablerUsers,
  specialty: TablerBriefcase,
  video: TablerVideo,
};

const InfoPill = React.forwardRef(
  (
    {children, icon, iconKey, iconSize = 3, ...rest}: Record<string, any>,
    ref: any,
  ) => {
    const PillIcon = icon || INFO_PILL_ICONS[iconKey] || null;

    return (
      <MetaPill ref={ref} gap={PillIcon ? 1.5 : undefined} {...rest}>
        {PillIcon ? (
          <Icon
            as={PillIcon}
            boxSize={iconSize}
            flexShrink={0}
            aria-hidden="true"
          />
        ) : null}
        {children}
      </MetaPill>
    );
  },
);

InfoPill.displayName = 'InfoPill';

export default InfoPill;
